import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import HealthCheck from './views/HealthCheck/HealthCheck';
let urlRoute = window.location;

ReactDOM.render((
	urlRoute.pathname === "/HealthCheck" ? <HealthCheck/> : <BrowserRouter basename='/payment'><App/></BrowserRouter>
), document.getElementById('root'));
